import { AfterViewInit, Component, OnInit, ViewEncapsulation, Inject, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatStepper, MatStep } from '@angular/material/stepper';
import { validationPatterns } from '../_helpers/validationPatterns';
import { HttpResponse } from '@angular/common/http';
import { ConfiguracionInicialDTO } from '../entity-models/configuracionInicialDTO.model';
import { ApiService } from '../_services/api.service';
import { CategoriaObjetoFinanciable, ICategoriaObjetoFinanciable } from '../entity-models/categoria-objeto-financiable.model';
import { SectorEconomico } from '../entity-models/sector-economico.model';
import { CategoriaAgricola } from '../entity-models/categoria-agricola.model';
import { CategoriaEmpresa } from '../entity-models/categoria-empresa.model';
import { fakeData } from '../entity-models/fakeData';
import { Cliente } from '../entity-models/cliente.model';
import { ObjetoFinanciable } from '../entity-models/objeto-financiable.model';
import { SpinnerService } from '../_services/spinnerService';
import { ActivatedRoute } from '@angular/router';
import { sinIva } from '../_helpers/utils';
import { CAT_MEDIANA_TRAMO_1, CAT_MEDIANA_TRAMO_2, CAT_PEQ_TRAMO_1, CAT_PEQ_TRAMO_2, ID_CATEGORIA_MAXIMA, LINEAS_CAPITAL_TRABAJO } from '../constantes';
import { DetalleLinea } from '../entity-models/detalle-linea.model';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.less'],
    encapsulation: ViewEncapsulation.None,
    providers: []
})

export class HomeComponent implements OnInit, AfterViewInit {

    @ViewChildren(MatCheckbox) checkboxes: QueryList<MatCheckbox>; // Para limpiar los checkboxes
    @ViewChildren(MatStep) steps: QueryList<MatStep>; // Para ubicar que pasos estan disponibles

    rubro: string;
    options: string;
    title = 'ftyc';
    nombre: string;
    cuit: string;
    nacimiento: string;
    celular: number;
    email: string;
    cliente: Cliente;
    pymeNueva: boolean;
    sectorEconomico: SectorEconomico = new SectorEconomico();
    sectorAgricola: boolean;
    actividad: number;
    hectareas: number;

    cantidadSimulaciones: number = 0;

    datosFormGroup: FormGroup;
    pymeNuevaFormGroup: FormGroup;
    financiarFormGroup: FormGroup;
    secondFormGroup: FormGroup;

    isMobile: boolean = false;
    showSimulacion = false;
    modoConsulta: boolean = false;

    msjAlertaObjFinanciable: boolean = false;

    destino = ['Inversion', 'Capital de Trabajo', 'Eficiencia Hídrica', 'Capital de Trabajo', 'Inversión Ganadería', 'Capital de Trabajo Ganadería'];
    tiposDestinosSeleccionados = [];
    destinosSeleccionados = [];
    configuracion: ConfiguracionInicialDTO = fakeData;
    categoriasObjetosFinanciables?: ICategoriaObjetoFinanciable[] = [];
    categoriasEmpresa: CategoriaEmpresa[] = [];
    categoriaInicial: CategoriaEmpresa = new CategoriaEmpresa();
    categoriaAgricola: CategoriaAgricola = new CategoriaAgricola();
    disableAnimation: boolean = true;

    pasoIdsVisibles: any[] = []; // Contiene la lista de pasos visibles

    constructor(
        private _formBuilder: FormBuilder,
        public dialog: MatDialog,
        private apiService: ApiService,
        private spinnerService: SpinnerService,
        private route: ActivatedRoute,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit() {

        this.apiService.getConfiguracion().subscribe((constantes: HttpResponse<ConfiguracionInicialDTO>) => {
            const constanstesResponse: ConfiguracionInicialDTO = constantes.body;
            this.configuracion = constanstesResponse;
        }, error1 => {
            this.spinnerService.hide();
        });

        this.route.fragment.subscribe((fragment: string) => {
            if (fragment && fragment === 'consulta') {
                this.modoConsulta = true;
            }
        });

        this.datosFormGroup = this._formBuilder.group({
            nombre: ['', [Validators.required]],
            cuit: ['', [Validators.required, Validators.pattern(validationPatterns.cuit)]],
            celular: ['', [Validators.required, Validators.pattern(validationPatterns.phone)]],
            email: ['', [Validators.required, Validators.pattern(validationPatterns.email)]]
        });

        this.pymeNuevaFormGroup = this._formBuilder.group({
            firstCtrl: [{ options: ['1'] }, Validators.required]
        });

        this.financiarFormGroup = this._formBuilder.group({
            FinanciarCtrl: [{ options: ['1'] }, Validators.required]
        });

        this.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

        if (!this.modoConsulta) {
            this.mostrarInicio();
        }
    }

    ngAfterViewInit() {
        // timeout required to avoid the dreaded 'ExpressionChangedAfterItHasBeenCheckedError'
        // Calcular pasos visibles
        this.steps.changes.subscribe(() => {
            this.cdr.detectChanges();
            // Filtramos los pasos visibles.
            const pasosVisibles = this.steps.filter(paso => paso._showError || paso.completed || paso.stepControl?.valid);
            // Ordenamos los pasos visibles según el índice en el mat-stepper.
            const pasosVisiblesOrdenados = pasosVisibles.sort((a, b) => this.steps.toArray().indexOf(a) - this.steps.toArray().indexOf(b));
            // Extraemos los IDs de los pasos visibles.
            this.pasoIdsVisibles = pasosVisiblesOrdenados.map(paso => paso.label);
            console.log('IDs de los pasos visibles:', this.pasoIdsVisibles);
        });
    }

    // 1er Paso (al marcar que si es pyme nueva)
    esPymeNueva(pymeNueva: boolean, stepper: MatStepper) {
        const categorias = this._getCategorias();
        this.pymeNueva = pymeNueva;
        this.categoriasEmpresa = this._getCategoriasEmpresa();
        this.categoriasObjetosFinanciables = this._getCategoriasObjetosFinanciables(pymeNueva, categorias);
        this.categoriaInicial = this.categoriasEmpresa[0];
        stepper.next();
        setTimeout(() => this.disableAnimation = false);
    }

    // 2do Paso (al seleccionar el objeto a financiar)
    setFinanciar(event: Event, objFinanciable: ObjetoFinanciable) {
        event.preventDefault();

        // Si ya esta seleccionado, y le hago click, lo quito.
        if (objFinanciable.accepted) {
            objFinanciable.accepted = false;
            this.destinosSeleccionados = this.arrayRemoveDestino(
                this.destinosSeleccionados,
                objFinanciable.id
            );
            if (this.destinosSeleccionados.length === 0) {
                this.tiposDestinosSeleccionados = this.arrayRemoveTipoDestino(
                    this.tiposDestinosSeleccionados,
                    objFinanciable
                );
            }
            this.cantidadSimulaciones = this.destinosSeleccionados.length;
            return;
        }

        // Si no esta seleccionado...

        // .. y supera la cantidad de objetos financiables elegibles
        // lo quitamos y actualizamos

        if (this.tiposDestinosSeleccionados.length > 0) {
            objFinanciable.accepted = false;
            this.msjAlertaObjFinanciable = true;
            this.mostrarMsjAlertaFinanciable();
            this.cantidadSimulaciones = this.destinosSeleccionados.length;
            return;
        }

        // Todo ok para agregar el destino seleccionado.
        this.destinosSeleccionados.push(objFinanciable);
        this.tiposDestinosSeleccionados.push(objFinanciable);
        this.msjAlertaObjFinanciable = false;
        objFinanciable.accepted = true;
        this.cantidadSimulaciones = this.destinosSeleccionados.length
    }

    getIdLineaDestinoSeleccionado(): number {
        return this.destinosSeleccionados[0]?.linea.id;
    }

    getCategoriasAgricolasFiltradas() {
        return this.configuracion.categoriasAgricolas.filter(catAgricola => {
            const esCapitalTrabajo = LINEAS_CAPITAL_TRABAJO.includes(this.getIdLineaDestinoSeleccionado());
            const eligioCatAgricola = this.sectorAgricola;
            if (
                esCapitalTrabajo &&
                eligioCatAgricola &&
                catAgricola.categoriaEmpresa.id == CAT_MEDIANA_TRAMO_2
            ) {
                // Quitamos la categoria de la lista.
                return false;
            }
            // Agregamos todas las demas.
            return true;
        })
    }

    // 3er Paso (solo si es pyme nueva, al seleccionar sector)
    setCategoria(cat: CategoriaEmpresa, stepper: MatStepper) {
        this.categoriaInicial = cat;
        this.showSimulacion = false;
        if (this.pymeNueva) {
            this.sectorEconomico = cat.id == 1
                ? new SectorEconomico(1, "Agropecuario")
                : new SectorEconomico(99, "Otros sectores");
            stepper.next();
        } else {
            this._calcularYMostrarModal(cat, stepper);
        }
        setTimeout(() => {
            this.showSimulacion = true;
        });
    }

    // 3er Paso (al seleccionar el sector economico segun Cert MiPyME)
    setSectorEconomico(sector) {
        this.sectorAgricola = false;
        this.sectorEconomico = sector;
        this.filterCategoriasEmpresa();
    }

    // 4to Paso (al seleccionar actividad principal si es sector agro)
    setSectorAgricola(agricola: boolean) {
        this.categoriaAgricola = new CategoriaAgricola();
        return this.sectorAgricola = agricola;
    }

    // 5to Paso (al seleccionar la cantidad de hectareas)
    setHectareas(sectorAgricola: CategoriaAgricola, stepper: MatStepper) {
        this.categoriaInicial = sectorAgricola.categoriaEmpresa;
        this.categoriaAgricola = sectorAgricola;
        this._calcularYMostrarModal(this.categoriaInicial, stepper);
        this.showSimulacion = false;
        setTimeout(() => {
            this.showSimulacion = true;
        });
    }

    _calcularYMostrarModal(catEmpresa: CategoriaEmpresa, stepper: MatStepper) {
        const idLinea = this.destinosSeleccionados[0].linea.id;
        const nombreLinea = this.destinosSeleccionados[0].linea.nombre;
        const detalleLinea = this.configuracion.detallesLineas
            .filter((d) =>
                d.categoriaEmpresa.id === catEmpresa.id &&
                d.linea.id === idLinea
            )[0];
        if (typeof detalleLinea === 'undefined') {
            alert('No existe detalle linea de credito compatible con su categoria de empresa');
            console.error(`No se encontro una linea con ID ${idLinea}: ${nombreLinea} y categoria ${catEmpresa.id}: ${catEmpresa.nombre}`);
            return;
        }

        const montoMaximo = detalleLinea.topeSMVM * this.configuracion.constantes.salarioMinimoVitalMovil;

        // Preparar condiciones
        const esCatPeqTramo1 = catEmpresa.id == CAT_PEQ_TRAMO_1;
        const esCatPeqTramo2 = catEmpresa.id == CAT_PEQ_TRAMO_2;
        const esCategoriaMaxima = catEmpresa.id == ID_CATEGORIA_MAXIMA;
        const esMedianaTramo1 = catEmpresa.id == CAT_MEDIANA_TRAMO_1;
        const esCapitalTrabajo = LINEAS_CAPITAL_TRABAJO.includes(idLinea);

        const mostrarMensajeCategoriasPeqDivididas = esCatPeqTramo1 || esCatPeqTramo2;
        const mostrarMensajeSuperarMontoMaximo = ! (esCategoriaMaxima || (esMedianaTramo1 && esCapitalTrabajo));

        this.mostrarModalinfo(
            stepper,
            catEmpresa,
            montoMaximo,
            detalleLinea.porcentajeInversion,
            idLinea,
            sinIva(idLinea),
            {
                mostrarMensajeCategoriasPeqDivididas,
                mostrarMensajeSuperarMontoMaximo
            }
        );
    }

    limpiarDestinoSeleccionado() {
        this.tiposDestinosSeleccionados = [];
        this.checkboxes.forEach(checkbox => checkbox.checked = false);
        const scrollToTop = window.setInterval(() => {
            const pos = window.scrollY;
            if (pos > 0) {
                window.scrollTo(0, pos - 20); // how far to scroll on each step
            } else {
                window.clearInterval(scrollToTop);
            }
        }, 16);
    }

    arrayRemoveTipoDestino(arr, value) {
        return arr.filter(function (ele) {
            return ele.id != value.id;
        });
    }

    arrayRemoveDestino(arr, value) {
        return arr.filter(function (ele) {
            return ele.id != value;
        });
    }

    setDatos() {
        this.cliente = new Cliente();
        this.cliente.nombre = this.datosFormGroup.controls.nombre.value;
        this.cliente.cuit = this.datosFormGroup.controls.cuit.value;
        this.cliente.celular = this.datosFormGroup.controls.celular.value;
        this.cliente.email = this.datosFormGroup.controls.email.value;
    }

    volverPymeNueva(stepper: MatStepper) {
        setTimeout(() => this.disableAnimation = true);
        stepper.previous();
    }

    _getCategorias() {
        const setOfCategorias = new Set<string>();
        for (const objF of this.configuracion.objetosFinanciables) {
            setOfCategorias.add(JSON.stringify(objF.categoriaObjetoFinanciable));
        }
        return setOfCategorias.values();
    }

    _getCategoriasEmpresa() {
        const uniqueIds = new Set();
        return this.configuracion.detallesLineas.map((linea) => {
                return linea.categoriaEmpresa;
            }).filter(item => {
                const isUnique = !uniqueIds.has(item.id);
                uniqueIds.add(item.id);
                return isUnique;
            });
    }

    _getCategoriasObjetosFinanciables(esPymeNueva: boolean, categorias: any) {
        const categoriasObjetosFinanciables = [];
        if (esPymeNueva) {
            for (const value of categorias) {
                const obj: CategoriaObjetoFinanciable = JSON.parse(value);
                obj.objetosFinanciables = this.configuracion.objetosFinanciables.filter(val => val.ocultoStartUp === false)
                    .filter(o => o.categoriaObjetoFinanciable.id === obj.id);
                categoriasObjetosFinanciables.push(obj);
            }
        } else {
            for (const value of categorias) {
                const obj: CategoriaObjetoFinanciable = JSON.parse(value);
                obj.objetosFinanciables = this.configuracion.objetosFinanciables.filter(o => o.categoriaObjetoFinanciable.id === obj.id);
                categoriasObjetosFinanciables.push(obj);
            }
        }
        return categoriasObjetosFinanciables;
    }



    esSectorAgropecuario() {
        return (this.sectorEconomico.id === 1) ? true : false;
    }

    esSectorAgricola() {
        return this.sectorAgricola;
    }

    inicioDeActividad(act: number) {
        console.log('Actividad: ' + act);
        this.actividad = act;
    }

    checkCantidadSimulaciones() {
        return this.cantidadSimulaciones = (this.tiposDestinosSeleccionados.length > 1) ? 2 : 1;
    }

    resetValores() {
        this.pymeNueva = false;
        this.sectorEconomico = new SectorEconomico();
        this.sectorAgricola = false;
        this.actividad = 0;
        this.hectareas = 0;
    }

    mostrarMsjAlertaFinanciable() {
        const dialogRef = this.dialog.open(AlertaObjetoFinanciable);
        dialogRef.afterClosed().subscribe(result => {
            console.log(`Dialog result: ${result}`);
        });
    }

    mostrarCertificado() {
        const dialogRef = this.dialog.open(Certificado);
        dialogRef.afterClosed().subscribe(result => {});
    }

    mostrarModalinfo(
        stepper: any,
        categoria: any,
        monto: any,
        porcentajeInversion: number,
        idLinea: number,
        sinIva: boolean,
        visibilidad: Record<string, any>
    ) {
        const dialogRef = this.dialog.open(Modalinfo, {
            data: {
                stepper,
                categoria,
                monto,
                porcentajeInversion,
                idLinea,
                sinIva,
                visibilidad,
            }
        });
        dialogRef.afterClosed().subscribe(result => {});
    }

    mostrarPyme() {
        const dialogRef = this.dialog.open(Pyme);
        dialogRef.afterClosed().subscribe(result => {});
    }

    mostrarInicio() {
        const dialogRef = this.dialog.open(Inicio, {
            backdropClass: 'backdropBackground'
        });
        dialogRef.afterClosed().subscribe(result => {});
    }

    mostrarLegal2() {
        const dialogRef = this.dialog.open(Legal2);
        dialogRef.afterClosed().subscribe(result => {});
    }

    mostrarLegal3() {
        const dialogRef = this.dialog.open(Legal3);
        dialogRef.afterClosed().subscribe(result => {});
    }

    mostrarLegal4() {
        const dialogRef = this.dialog.open(Legal4);
        dialogRef.afterClosed().subscribe(result => {});
    }

    mostrarLegal5() {
        const dialogRef = this.dialog.open(Legal5);
        dialogRef.afterClosed().subscribe(result => {});
    }

    checkAccepted(items) {
        return items.filter((i) => i.accepted === true).length > 0 ? true : false;
    }

    filterCategoriasEmpresa() {
        const objetoFinananciable: ObjetoFinanciable = this.destinosSeleccionados[0];
        if (objetoFinananciable) {
            const setOfCategoriasEmpresa = new Set<string>();
            for (const detL of this.configuracion.detallesLineas.filter((d) => d.linea.id === objetoFinananciable.linea.id)) {
                setOfCategoriasEmpresa.add(JSON.stringify(detL.categoriaEmpresa));
            }
            this.categoriasEmpresa = [];
            for (const value of setOfCategoriasEmpresa.values()) {
                const obj: CategoriaEmpresa = JSON.parse(value);
                this.categoriasEmpresa.push(obj);
            }
        }
        return this.categoriasEmpresa;
    }

    imprimirSimulacion() {
        // this.apiService.sendEmail(3).subscribe();
    }

    descargarArchivo(_buffer, _type, name) {
        const blob = new Blob([_buffer], { type: _type });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = name;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
}

@Component({
    selector: 'certificado',
    templateUrl: 'certificado.html',
    styleUrls: ['./home.component.less'],
})

export class Certificado {
    constructor() {
    }
}

@Component({
    selector: 'modalinfo',
    templateUrl: 'modalinfo.html',
    styleUrls: ['./home.component.less'],
})

export class Modalinfo {
    constructor(@Inject(MAT_DIALOG_DATA) public data: {
        stepper: any,
        categoria: any,
        monto: any,
        porcentajeInversion: number,
        idLinea: number,
        sinIva: boolean,
        visibilidad: Record<string, any>,
    }) {}
}

@Component({
  selector: 'excedido',
  templateUrl: 'excedido.html',
  styleUrls: ['./home.component.less'],
})

export class Excedido {
  constructor(@Inject(MAT_DIALOG_DATA) public data: {
      categoria: any,
      monto: any,
  }) {}
}


@Component({
    selector: 'AlertaObjetoFinanciable',
    templateUrl: 'alerta-objeto-financiable.html',
    styleUrls: ['./home.component.less'],
})

export class AlertaObjetoFinanciable {

    constructor() {
    }
}

@Component({
    selector: 'pyme',
    templateUrl: 'pyme.html',
    styleUrls: ['./home.component.less'],
})

export class Pyme {

    constructor() {
    }
}

@Component({
    selector: 'inicio',
    templateUrl: 'inicio.html',
    styleUrls: ['./home.component.less'],
})

export class Inicio {

    constructor() {
    }
}

@Component({
    selector: 'legal2',
    templateUrl: 'legal2.html',
    styleUrls: ['./home.component.less'],
})

export class Legal2 {

    constructor() {
    }
}

@Component({
    selector: 'legal3',
    templateUrl: 'legal3.html',
    styleUrls: ['./home.component.less'],
})

export class Legal3 {

    constructor() {
    }
}

@Component({
    selector: 'legal4',
    templateUrl: 'legal4.html',
    styleUrls: ['./home.component.less'],
})

export class Legal4 {

    constructor() {
    }
}

@Component({
    selector: 'legal5',
    templateUrl: 'legal5.html',
    styleUrls: ['./home.component.less'],
})

export class Legal5 {

    constructor() {
    }
}
